import media from '@oneflare/flarekit/lib/libs/media';
import { styled } from 'styled-components';

export const BusinessRegistrationWrapperStyled = styled.div`
  background-color: ${({ theme }) => theme.color.secondary};
  padding: 40px 0;

  ${media.mdUp`
    padding: 64px 0px;
  `}

  ${media.lgUp`
    padding: 80px 0;
  `}
`;

export const BusinessRegistrationStyled = styled.div`
  border-radius: 8px;
  text-align: center;
  margin: 0 auto;

  ${media.mdUp`
    max-width: 75%;
  `}

  ${media.lgUp`
    max-width: 100%;
  `}
`;
